var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "profile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M19.273,11.136A3.636,3.636,0,1,1,15.636,7.5,3.636,3.636,0,0,1,19.273,11.136Zm-1.818,0a1.818,1.818,0,1,1-1.818-1.818A1.818,1.818,0,0,1,17.455,11.136Z",
    transform: "translate(-5.636 -3.864)",
    fill: "currentColor",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M11.5,1.5a10,10,0,1,0,10,10A10,10,0,0,0,11.5,1.5Zm-8.182,10a8.149,8.149,0,0,0,1.735,5.038,8.184,8.184,0,0,1,12.954-.076A8.182,8.182,0,1,0,3.318,11.5ZM11.5,19.682a8.148,8.148,0,0,1-5.156-1.829,6.366,6.366,0,0,1,10.388-.062A8.149,8.149,0,0,1,11.5,19.682Z",
    transform: "translate(-1.5 -1.5)",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.baa93dfc81e904a012b3e836f3bea8e6.svg";
export { ForwardRef as ReactComponent };